const scriptTag = document.getElementById("termlynx-config")!;

export interface ITermLynxConfig {
  env: "Development" | "Staging" | "Production";
  sentryDsn: string;
  tooLargeUrl: string;
}

const config = JSON.parse(scriptTag.innerText) as ITermLynxConfig;

export default config;
